<div>
    <div class="box">
        <div class="title" (click)="toggle()">
            <ng-content select="[title]"></ng-content>
            <i [ngClass]="collapsed ? 'dx-icon-chevrondown chevron' : 'dx-icon-chevronup chevron'"></i>
        </div>
        <div class="content" [hidden]="collapsed">
            <ng-content></ng-content>
        </div>
    </div>
</div>
